import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';

@Component({
    selector: '[parcella_entity_view]',
  templateUrl: 'parcella-entity-view.component.html',
})

export class ParcellaEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element: ParcellaGiudiziale;
}
